var Utils = {

	initOauth : function(str) {
		OAuth.initialize( settings.oauth );
	},

	postTwitter:function(blob, message){
		OAuth.popup("twitter").then(function(result) {
			var data = new FormData();
			data.append('status', message);
			data.append('media[]', blob, 'poster.png');
			return result.post('/1.1/statuses/update_with_media.json', {
				data: data,
				cache:false,
				processData: false,
				contentType: false
			});

			}).done(function(data){
				//todo once the image is sent
	
			}).fail(function(e){
				$(dom.modal.shareErrorLinkId + " .alert__message").html( localisation.modal.errorShare )
				$(dom.modal.shareErrorLink).trigger("click");
		});
	},

	postFacebook:function(blob, message){
		OAuth.popup("facebook").then(function(result) {
			console.log("hello")
		var data = new FormData();
		data.append( "access_token" , result.access_token );
		data.append( "message", message );
		data.append( "source", blob );
		return result.post('/me/photos', {
			data: data,
			cache:false,
			processData: false,
			contentType: false
		});

		}).done(function(data){

		}).fail(function(e){
			$(dom.modal.shareErrorLinkId + " .alert__message").html( localisation.modal.errorShare )
			$(dom.modal.shareErrorLink).trigger("click");

		});

	},

	getBlob:function(dataURI, callback){
		// convert base64 to raw binary data held in a string
		// doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
		var byteString = atob(dataURI.split(',')[1]);

		// separate out the mime component
		var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

		// write the bytes of the string to an ArrayBuffer
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);
		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		// write the ArrayBuffer to a blob, and you're done
		var bb = new Blob([ab]);
		return bb;
	},

	///////////////////////////////////////////////
	// GET BODY HEIGHT
	//////////////////////////////////////////////
	getPageWidth : function(){
		var w = $(dom.viewport).width();
		return w;
	},
	
	getPageHeights : function(){
		var headerHeight = $(dom.header).height();
		var footerHeight =  36;
		var navHeight = $(dom.navigation.next).height() + 20;
		var viewportHeight = $(dom.viewport).height() ;
		if($(dom.viewport).height()< $(dom.viewport).width()){
			return null;
		}
		var margins = 20;
		var pageHeight = viewportHeight - ( navHeight + footerHeight + headerHeight ) - 20
		var pageHeightShare = viewportHeight-( footerHeight + headerHeight ) - 10
		var page = {};
		page.body = pageHeight
		page.share = pageHeightShare;
		page.bodyW = $(dom.viewport).width();
		return page;
	},

	getBodyHeight : function( hasNav ){

		var headerHeight = $(dom.header).height();
		var footerHeight =  36;//$(dom.footer).height(); this is hard coded because footer 
		var navHeight = $(dom.navigation.next).height();

		var bottomHeight = footerHeight;
		if(hasNav) bottomHeight += navHeight + 20;
		var viewportHeight = $(dom.viewport).height() ;
		var margins = 20;
		if(!hasNav) margins = 10;

		var bodyHeight = viewportHeight - ( bottomHeight + headerHeight ) - margins;
		return bodyHeight;
	},

	///////////////////////////////////////////////
	// CHECK PROFANITY
	//////////////////////////////////////////////

	checkProfanity : function( string ){
		if(string.search(/\b(4r5e|5h1t|5hit|a55|anal|anus|ar5e|arrse|arse|ass|ass-fucker|asses|assfucker|assfukka|asshole|assholes|asswhole|a_s_s|b!tch|b00bs|b17ch|b1tch|ballbag|balls|ballsack|bastard|beastial|beastiality|bellend|bestial|bestiality|bi\+ch|biatch|bitch|bitcher|bitchers|bitches|bitchin|bitching|bloody|blow job|blowjob|blowjobs|boiolas|bollock|bollok|boner|boob|boobs|booobs|boooobs|booooobs|booooooobs|breasts|buceta|bugger|bum|bunny fucker|butt|butthole|buttmuch|buttplug|c0ck|c0cksucker|carpet muncher|cawk|chink|cipa|cl1t|clit|clitoris|clits|cnut|cock|cock-sucker|cockface|cockhead|cockmunch|cockmuncher|cocks|cocksuck|cocksucked|cocksucker|cocksucking|cocksucks|cocksuka|cocksukka|cok|cokmuncher|coksucka|coon|cox|crap|cum|cummer|cumming|cums|cumshot|cunilingus|cunillingus|cunnilingus|cunt|cuntlick|cuntlicker|cuntlicking|cunts|cyalis|cyberfuc|cyberfuck|cyberfucked|cyberfucker|cyberfuckers|cyberfucking|d1ck|damn|dick|dickhead|dildo|dildos|dink|dinks|dirsa|dlck|dog-fucker|doggin|dogging|donkeyribber|doosh|duche|dyke|ejaculate|ejaculated|ejaculates|ejaculating|ejaculatings|ejaculation|ejakulate|f u c k|f u c k e r|f4nny|fag|fagging|faggitt|faggot|faggs|fagot|fagots|fags|fanny|fannyflaps|fannyfucker|fanyy|fatass|fcuk|fcuker|fcuking|feck|fecker|felching|fellate|fellatio|fingerfuck|fingerfucked|fingerfucker|fingerfuckers|fingerfucking|fingerfucks|fistfuck|fistfucked|fistfucker|fistfuckers|fistfucking|fistfuckings|fistfucks|flange|fook|fooker|fuck|fucka|fucked|fucker|fuckers|fuckhead|fuckheads|fuckin|fucking|fuckings|fuckingshitmotherfucker|fuckme|fucks|fuckwhit|fuckwit|fudge packer|fudgepacker|fuk|fuker|fukker|fukkin|fuks|fukwhit|fukwit|fux|fux0r|f_u_c_k|gangbang|gangbanged|gangbangs|gaylord|gaysex|goatse|God|god-dam|god-damned|goddamn|goddamned|hardcoresex|hell|heshe|hoar|hoare|hoer|homo|hore|horniest|horny|hotsex|jack-off|jackoff|jap|jerk-off|jism|jiz|jizm|jizz|kawk|knob|knobead|knobed|knobend|knobhead|knobjocky|knobjokey|kock|kondum|kondums|kum|kummer|kumming|kums|kunilingus|l3i\+ch|l3itch|labia|lust|lusting|m0f0|m0fo|m45terbate|ma5terb8|ma5terbate|masochist|master-bate|masterb8|masterbat*|masterbat3|masterbate|masterbation|masterbations|masturbate|mo-fo|mof0|mofo|mothafuck|mothafucka|mothafuckas|mothafuckaz|mothafucked|mothafucker|mothafuckers|mothafuckin|mothafucking|mothafuckings|mothafucks|mother fucker|motherfuck|motherfucked|motherfucker|motherfuckers|motherfuckin|motherfucking|motherfuckings|motherfuckka|motherfucks|muff|mutha|muthafecker|muthafuckker|muther|mutherfucker|n1gga|n1gger|nazi|nigg3r|nigg4h|nigga|niggah|niggas|niggaz|nigger|niggers|nob|nob jokey|nobhead|nobjocky|nobjokey|numbnuts|nutsack|orgasim|orgasims|orgasm|orgasms|p0rn|pawn|pecker|penis|penisfucker|phonesex|phuck|phuk|phuked|phuking|phukked|phukking|phuks|phuq|pigfucker|pimpis|piss|pissed|pisser|pissers|pisses|pissflaps|pissin|pissing|pissoff|poop|porn|porno|pornography|pornos|prick|pricks|pron|pube|pusse|pussi|pussies|pussy|pussys|rectum|retard|rimjaw|rimming|s hit|s.o.b.|sadist|schlong|screwing|scroat|scrote|scrotum|semen|sex|sh!\+|sh!t|sh1t|shag|shagger|shaggin|shagging|shemale|shi\+|shit|shitdick|shite|shited|shitey|shitfuck|shitfull|shithead|shiting|shitings|shits|shitted|shitter|shitters|shitting|shittings|shitty|skank|slut|sluts|smegma|smut|snatch|son-of-a-bitch|spac|spunk|s_h_i_t|t1tt1e5|t1tties|teets|teez|testical|testicle|tit|titfuck|tits|titt|tittie5|tittiefucker|titties|tittyfuck|tittywank|titwank|tosser|turd|tw4t|twat|twathead|twatty|twunt|twunter|v14gra|v1gra|vagina|viagra|vulva|w00se|wang|wank|wanker|wanky|whoar|whore|willies|willy|xrated|xxx)\b/gi) > -1 ){
			return true;
		} else {
			return false;
		}
	},

	///////////////////////////////////////////////
	// FILTER OUT NONE ASCI EMOJI
	//////////////////////////////////////////////
	
	filterAsci : function( string ){
		return string.replace(/[^\x00-\xFF]/g, "");
	},

	///////////////////////////////////////////////
	// CHECK EMPTY STRING
	//////////////////////////////////////////////

	checkEmpty : function( string ){
		if( string.length > 0 ) return false;
		else return true;
	},

	///////////////////////////////////////////////
	// RESIZE IMAGE 
	//////////////////////////////////////////////
	resizeImage : function (img, width, ratio ) {

		var canvas = document.createElement( 'canvas' ),
		ctx = canvas.getContext( '2d' );

		// set its dimension to target size
		canvas.width = width;
		canvas.height = width * ratio;

		// draw source image into the off-screen canvas:
		ctx.drawImage(img, 0, 0, width, ( width * ratio ) );
		console.log(width)
		console.log(width * ratio)
		//MAKE IT GRAYSCALE
		var imageData = ctx.getImageData(0, 0, width, ( width * ratio ) );
		var data = imageData.data;

		for(var i = 0; i < data.length; i += 4) {
			var brightness = 0.34 * data[i] + 0.5 * data[i + 1] + 0.16 * data[i + 2];
			// red
			data[i] = brightness;
			// green
			data[i + 1] = brightness;
			// blue
			data[i + 2] = brightness;
		}

		// overwrite original image
		ctx.putImageData(imageData, 0, 0);
		// encode image to data-uri with base64 version of compressed image
		return canvas.toDataURL( 'image/png' , 10 );
	},

	
	// reads exif data draws the image again on canvas with the correct rotation
	getExifOrientation : function( b64 ){
		var arr = Utils.base64ToArrayBuffer( b64 ) ;
		var exif = EXIF.readFromBinaryFile( arr );
		return exif.Orientation;
	},

	fixExifOrientation : function( img ,b64, width , height ){
		var arr = Utils.base64ToArrayBuffer( b64 ) ;
		var exif = EXIF.readFromBinaryFile( arr );
		
		if( (!exif.Orientation) || (exif.Orientation == 0)||(exif.Orientation == 1)){
			return b64;
		}

		var canvas = document.createElement( 'canvas' ),
		ctx = canvas.getContext( '2d' );
	

	//	document.body.appendChild(canvas)
		// draw source image into the off-screen canvas:
		canvas.width = width;
		canvas.height = height;

		ctx.drawImage(img, 0, 0, width, height );

		if(exif.Orientation){
			switch(exif.Orientation){
				 case 2:
				// horizontal flip
				ctx.translate(canvas.width, 0);
				ctx.scale(-1, 1);
				ctx.drawImage(img, 0 ,0, width, height );
			break;
			case 3:
				// 180° rotate left
				ctx.clearRect(0,0,canvas.width,canvas.height);
				ctx.translate(canvas.width, canvas.height);
				ctx.rotate(Math.PI);
				ctx.drawImage(img, 0 ,0, width, height );
				break;
			case 4:
				// vertical flip
				ctx.translate(0, canvas.height);
				ctx.scale(1, -1);
				ctx.drawImage(img, 0 ,0, width, height );
				break;
			case 5:
				canvas.width = height;
				canvas.height = width;
				ctx.clearRect(0,0,canvas.width,canvas.height);
				// vertical flip + 90 rotate right
				ctx.rotate(0.5 * Math.PI);
				ctx.scale(1, -1);
				ctx.drawImage(img, 0 ,0, width, height );
				break;

			case 6:
				
				// 90° rotate right
				canvas.width = height;
				canvas.height = width;
				ctx.clearRect(0,0,canvas.width,canvas.height);
				ctx.rotate(0.5 * Math.PI);
				ctx.translate(0, - height);
				ctx.drawImage(img, 0 ,0, width, height );
				break;
			
			case 7:
				canvas.width = height;
				canvas.height = width;
				// horizontal flip + 90 rotate right
				ctx.clearRect(0,0,canvas.width,canvas.height);
				ctx.rotate(0.5 * Math.PI);
				ctx.translate(width, -height);
				ctx.scale(-1, 1);
				ctx.drawImage(img, 0 ,0, width, height );
				break;
			
			case 8:
				// 90° rotate left
				canvas.width = height;
				canvas.height = width;
				ctx.rotate(-0.5 * Math.PI);
				ctx.translate(-width, 0);
				ctx.drawImage(img, 0 ,0, width, height );
				break;
			}
		}
			
		return canvas.toDataURL( 'image/png' , 10 );
	},

	base64ToArrayBuffer : function ( base64 ) {
		base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
		
		var binaryString = atob(base64);
		var len = binaryString.length;
		var bytes = new Uint8Array(len);
		for (var i = 0; i < len; i++) {
		    bytes[i] = binaryString.charCodeAt(i);
		}
		return bytes.buffer;
	},

	createImage : function( src , callBack ){
		var img = new Image();
		img.onload = callBack;
		img.src = src;
		return img;
	},

};